import { useShallow } from "zustand/react/shallow";
import { useAppStore } from "../appStore";

export const useAppActions = () =>
  useAppStore(
    useShallow((state) => ({
      setChangeLanguage: state.setChangeLanguage,
      setUserInfo: state.setUserInfo,
      setUserProfile: state.setUserProfile,
      setBreadcrumb: state.setBreadcrumb,
      setModuleName: state.setModuleName,
      setMessage: state.setMessage,
      fetchCountryCode: state.fetchCountryCode,
      fetchNationality: state.fetchNationality,
      setTheme: state.setTheme,
    }))
  );

export const useUserInfos = () => useAppStore((state) => state.userInfo);

export const useUserProfile = () => useAppStore((state) => state.userProfile);

export const useModuleName = () => useAppStore((state) => state.moduleName);

export const useBreadcrumbLists = () =>
  useAppStore((state) => state.breadcrumb);

export const useLanguage = () => useAppStore((state) => state.language);

export const useMessage = () => useAppStore((state) => state.message);

export const useCountryCode = () =>
  useAppStore(
    useShallow((state) => ({
      countryCodeData: state.countryCodes.data,
      countryCodeLoading: state.countryCodes.loading,
      countryCodeError: state.countryCodes.error,
    }))
  );

export const useNationalities = () =>
  useAppStore(
    useShallow((state) => ({
      nationality: state.nationality.data,
      nationalityLoading: state.nationality.loading,
      nationalityError: state.nationality.error,
    }))
  );

export const useTheme = () => useAppStore((state) => state.theme);
